import React from 'react';

function CheckmarkCircleOutline() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M11.852 0C5.31 0 0 5.31 0 11.852c0 6.542 5.31 11.852 11.852 11.852 6.542 0 11.852-5.31 11.852-11.852C23.704 5.31 18.394 0 11.852 0zm0 21.333c-5.227 0-9.482-4.254-9.482-9.481S6.625 2.37 11.852 2.37c5.227 0 9.481 4.255 9.481 9.482 0 5.227-4.254 9.481-9.481 9.481z" />
      <path d="M10.371 16.31L6 11.94l1.233-1.233 3.138 3.13L17.007 7.2l1.233 1.241z" />
    </svg>
  );
  /* eslint-enable */
}

export default CheckmarkCircleOutline;



// WEBPACK FOOTER //
// ./src/common/icons/CheckmarkCircleOutline.js